import styled from 'styled-components'

export const SkeletonContainer = styled.div`
  :not(:first-child) {
    margin-top: 16px;
  }
`
